module.exports = __webpack_public_path__ + "static/media/down-arrow-grey.6b631034.svg";